import { getInstance } from './index'
import Store from '@/store'

export const WaitForAuthentication = function () {
  return new Promise((resolve, reject) => {
    const authService = getInstance()

    if (!authService.loading) return resolve(authService)

    authService.$watch('loading', loading => {
      if (!loading) return resolve(authService)
    })
  })
}

export const hasAccess =
  (...accesses) =>
  (to, from, next) => {
    return isAuthenticated(to, from, async () => {
      if (accesses.some(access => Store.getters.hasAccess(access))) return next()
      return next({ name: 'noaccess' })
    })
  }

export const isSuperAdmin = async (to, from, next) => {
  return isAuthenticated(to, from, async () => {
    if (Store.getters.isSuperadmin) return next()
    return next({ name: 'noaccess' })
  })
}

export const isOwner = async (to, from, next) => {
  return isAuthenticated(to, from, async () => {
    if (Store.getters.isOwner) return next()
    return next({ name: 'noaccess' })
  })
}

export const isAuthenticated = async (to, from, next) => {
  let authService = await WaitForAuthentication()

  if (authService.isAuthenticated) {
    if (!authService.isVerified) return next({ name: 'noaccess' })

    return next()
  }

  authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
}
